import React from "react";
import styled from "styled-components";

const OverLay = styled.div``;
const Root = styled.div`
  position: fixed;
  width: 466px;
  padding: 30px;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;
const Container = styled.div``;
const LeftContainer = styled.div`
@media(max-width:768px){
display:none;
}
`;
const RightContainer = styled.div``;

const BuyNow = ({ setShowPopup, showPopup }) => {
  return (
    <OverLay
      onClick={() => {
        setShowPopup(false);
      }}
    >
      <Root onClick={(e) => e.stopPropagation()}>
        <CloseIcon onClick={() => setShowPopup(false)}>
          <i class="fa-solid fa-xmark"></i>
        </CloseIcon>
        <Container>
          <LeftContainer>
            <ImageWrapper>
              <Image />
            </ImageWrapper>
          </LeftContainer>
          <RightContainer></RightContainer>
        </Container>
      </Root>
    </OverLay>
  );
};

export default BuyNow;
